module.exports = __webpack_public_path__ + "img/sii-imagotipo-blanco.4b0d2825.svg";